$(document).ready(function() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");
 

  if ($("#productsSlider").length > 0) {
    productsSlider($("#productsSlider"));
  }
  if ($("#historySlider").length > 0) {
    historySlider($("#historySlider"));
  }
  slideSidebarMenu();
  fixedNav();
  slideContact();
  replaceSvgInline();
  mobileMenu();
  scrollToTop();
  scrollVideo();
  changeAttachmentLabelName();
  showRecruitmentForm();
  callProductPopup();
  playVideoOnClick();
  addDataToGutenbergGallery();
  addBtnToMenuItemWithSubmenu();
  toggleReadMore();


  
});




$(window).on('scroll', function () {
  fixedNav();
});

$(window).on('resize', function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");
});


function scrollToTop() {
  $('.scroll-top').on('click', function(e) {
    e.preventDefault();
    $('html,body').animate({
        scrollTop: 0
    }, 700);
  });
}

function scrollVideo() {
  $('.scroll-btn').on('click', function(e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $('.start-movie')[0].scrollHeight
    }, 700);
  });
}



var productsSlider = function(el) {
  el.slick({
    fade: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 2000,
    dots: false,
    accessibility: false,
    arrows: true,
    centerPadding: '110px',
    appendArrows: '#productsSliderArrows',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '110px',
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '80px',
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '70px',
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      }
    ]
  });
};

var historySlider = function(el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 2000,
    dots: false,
    accessibility: false,
    arrows: false,
    draggable: false,
    asNavFor: '.history-nav'
  });

  $('.history-nav').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '#historySlider',
    dots: false,
    arrows: true,
    centerMode: true,
    focusOnSelect: true,
    draggable: false,
    appendArrows: '#historySliderArrows',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });
 
  $('.history-nav .slick-slide').removeClass('slick-active');
 
  $('.history-nav .slick-slide').eq(0).addClass('slick-active');
 
  $('#historySlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.history-nav .slick-slide').removeClass('slick-active');
    $('.history-nav .slick-slide').eq(mySlideNumber).addClass('slick-active');
 });
};




function slideContact() {
  var btn = $('.department-contact__department');
  var content = $('.department-contact__content');
  $(btn).on('click', function(e) {
    e.preventDefault();
    if( $(this).hasClass('department-contact__department--active') ) {
      btn.removeClass('department-contact__department--active');
      $(this).next(content).slideToggle('slow');
    } else {
      btn.removeClass('department-contact__department--active');
      $('.department-contact__content').hide('slow');
      $(this).toggleClass('department-contact__department--active');
      $(this).next(content).slideToggle('slow');
    }
  });
}

function slideSidebarMenu() {
  btn = $('.sidebar-menu__btn');
  sidebarMenu = $('.sidebar-menu');
  btn.on('click', function(e) {
    e.preventDefault();
    sidebarMenu.toggleClass('sidebar-menu--active');
    $('.sidebar-menu__btn-text').toggleClass('sidebar-menu__btn-text--active');
    $('.sidebar-menu__name').toggleClass('sidebar-menu__name--active');
    $('.sidebar-menu__btn-icon').toggleClass('sidebar-menu__btn-icon--active');
  });

  $('.sidebar-menu__btn-text').on('click', function(e) {
    e.stopPropagation();
  });
}

function mobileMenu() {
  $('#mobileBurger').on('click', function() {
    $('.mobile-burger__line').toggleClass('animate');
    $('.main-menu').toggleClass('main-menu--active');
    $('.select-language__mobile').toggleClass('select-language__mobile--active');
    $('.phone-contact__mobile').toggleClass('phone-contact__mobile--active');
  })
}

function fixedNav() {
  var pageHeader = $('.page-header');
  if (window.pageYOffset >= 10) {
    pageHeader.addClass('page-header--fixed');
  } else {
    pageHeader.removeClass('page-header--fixed');
  }
}

function replaceSvgInline() {
  $('.inline-svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    jQuery.get(imgURL, function(data) {
        var $svg = jQuery(data).find('svg');
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass+' custom-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);

    }, 'xml');
  });
}



function showRecruitmentForm() {
  var $recruitmentForm = $('.recruitment-container');
  var $buttonShowForm = $('.single-job__btn');
  $($buttonShowForm).on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('single-job__btn--active');
    $recruitmentForm.slideToggle('medium');
  });
}

function callProductPopup() {
  $("#callProdcutPopup").hide();
  $('#callForProduct').on('click',function(e) {
    e.preventDefault();
    var $productName = $('#productName').text();
    $('#callProductName').val($productName);
    $("#callProdcutPopup").fadeIn(300);
  });
  $('#callProdcutPopup').on('click',function(e) {
    $('#callProdcutPopup').fadeOut(300);
   });
  $('#closePopup').on('click', function() {
    $("#callProdcutPopup").fadeOut(300);
  });
  $('#callProdcutPopup').find($('.popup-product')).on('click', function(e){
    e.stopPropagation();
   });
}



function changeAttachmentLabelName() {
  $('#your-file').change(function() {
    var $fileName = $('#your-file')[0].files[0].name;
    $('#first-file').text($fileName);
  });
}


function playVideoOnClick() {
  $(".single-movie__link").on('click',function(e) {
    $buttonId = $(this).attr('id');
    $embedData = $jsonCodesArray[$buttonId];
    $embedCode = $embedData['movie_code'];
    console.log('movie-klik');
    $(".video-overlay__iframe").append('<iframe class="video-overlay__video" src="https://www.youtube.com/embed/'+$embedCode+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    $('.video-pop').fadeIn(300);
  });
  $('.video-pop').on('click',function(e) {
    $('.video-pop').fadeOut(300);
    $('.video-overlay__video').remove();
  });
  $('.video-pop').find($('.video-overlay__video')).on('click', function(e){
    e.stopPropagation();
  });
}



function addDataToGutenbergGallery() {
  $('.blocks-gallery-grid .blocks-gallery-item a').each(function() {
    $(this).attr('data-lightbox', 'gallery');
  });
}


function addBtnToMenuItemWithSubmenu() {
  $('.sub-menu').each(function () {
    if($(this).parent().parent().hasClass('main-menu')) $('<button class="menu-item__show"></button>').insertBefore(this);
  });
  $('.menu-item__show').on('click', function() {
    $(this).next().slideToggle('medium');
    $(this).toggleClass('menu-item__show--active')
  })

}

function toggleReadMore(){
  $('.home-about__read-more').on('click', function(){
    $(this).children().last().toggleClass('home-about__arrow--active');
    $('.home-about__more').slideToggle('medium');
  })
}



















